import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  topbar: {
    alignItems: 'center',
    backgroundColor: theme.vars.palette.background.elevation2,
    borderBottom: `1px solid ${theme.vars.palette.border.light}`,
    display: 'flex',
    justifyContent: 'space-between',
    minHeight: theme.spacing(8),
    padding: theme.spacing(0, 3),
    position: 'sticky',
    top: 0,
    width: '100%',
    zIndex: 3
  },
  topbarBadge: {
    '& .MuiBadge-badge': {
      fontSize: '0.75rem',
      height: '1.25rem',
      lineHeight: '0.75rem',
      minWidth: '1.25rem',
      padding: '0rem 0.40625rem'
    }
  },
  topbarButton: {
    padding: theme.spacing(0.5)
  },
  topbarDrawer: {
    '& .MuiDrawer-paper': {
      padding: theme.spacing(0, 2),
      width: '20rem'
    }
  }
}));

export default useStyles;
